//#region src/generated/locales/de.ts
var templates = {
	"pd.submit.dialog.closeStay": `Daten bearbeiten`,
	"pd.submit.dialog.startPage": `Zur Startseite`
};
//#endregion
export { templates };
